/* eslint-disable camelcase */
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
/* eslint-disable no-template-curly-in-string */
/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import {
  Box,
  Table,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  // Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import InputAdornment from "@mui/material/InputAdornment";
import Search from "@mui/icons-material/Search";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
// import { useTranslation } from "react-i18next";
// import DeleteLab from "./delete_lab";
import Checkbox from "@mui/material/Checkbox";
import CargoLoader from "components/CargoLoader";
import FilterBar, { filterRows } from "components/FilterBar";
import Pagination, { usePagination } from "components/Pagination";

function CustomerOrders() {
  const [orders, setOrders] = useState([]);
  const [query, setQuery] = useState("");
  const [containers, setContainers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setloading] = useState(false);
  const [checked, setChecked] = useState([false]);

  const handleCheckChange = (event, index) => {
    setChecked((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.checked : el;
      })
    );
  };
  // const { t } = useTranslation();
  const fetchData = async () => {
    const customer_code = sessionStorage.getItem("customer_code");
    const headers = { ContentType: "application/json", Accept: "application/json" };
    const response = await fetch(
      `https://trust-cargo.co/anas_backend/api/customer_orders/${customer_code}`,
      {
        headers,
      }
    );
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setOrders(data["orders"]);
    setloading(false);
  };
  const getContainers = async () => {
    // const token = sessionStorage.getItem("token");
    // const headers = { ContentType: `application/json` };
    const response = await fetch("https://trust-cargo.co/anas_backend/api/containers");
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setContainers(data["containers"]);
  };
  const getCustomers = async () => {
    // const token = sessionStorage.getItem("token");
    // const headers = { ContentType: `application/json` };
    const response = await fetch("https://trust-cargo.co/anas_backend/api/customers");
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    // setCustomers((array) => [...array, data["customers"]]);
    setCustomers([data["customers"]]);
  };

  const getCustomersID = async (id) => {
    // const token = sessionStorage.getItem("token");
    // const headers = { ContentType: `application/json` };
    const response = await fetch(
      `https://trust-cargo.co/anas_backend/api/filter_orders_customer_id/${id}`
    );
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setOrders(data["orders"]);
  };
  const getContainersID = async (id) => {
    // const token = sessionStorage.getItem("token");
    // const headers = { ContentType: `application/json` };
    const response = await fetch(
      `https://trust-cargo.co/anas_backend/api/filter_orders_container_id/${id}`
    );
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setOrders(data["orders"]);
  };

  useEffect(() => {
    setloading(true);
    fetchData();
    getContainers();
    getCustomers();
  }, []);
  const handleChangeContainer = (event) => {
    getContainersID(event.target.value);
  };
  const handleChangeCustomer = (event) => {
    getCustomersID(event.target.value);
  };
  const navigate = useNavigate();
  const filteredRows = filterRows(orders, query);
  const pager = usePagination(filteredRows);
  return (
    <DashboardLayout>
      <SuiBox py={3}>
        <SuiBox mb={3}>
          <Card>
            <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SuiTypography variant="h6">Orders</SuiTypography>
            </SuiBox>
            <FilterBar
              value={query}
              onChange={setQuery}
              count={filteredRows.length}
              total={orders.length}
            />
            {loading ? (
              <div
                style={{
                  width: "1000",
                  height: "50px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CargoLoader />
              </div>
            ) : (
              <>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table">
                  <TableHead>
                    <TableRow style={{ display: "flex" }}>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                          Order Code
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                          Delivery Date
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                          Phone Number
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                          Customer
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                          Container
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                          Status
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                          Total Amount
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                          Total CTN
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                          Total G.W
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                          Total T/CBM
                        </TableCell>
                      </Box>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pager.pageRows.map((user, index) => (
                      <TableRow
                        key={user.name}
                        sx={{
                          // "&:last-child td, &:last-child th": { border: 0 },
                          display: "flex",
                        }}
                      >
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                            {user.order_code ?? "-"}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                            {user.delivery_date ?? "-"}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                            {user.phone_number ?? ""}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                            {user.customer_name ?? ""}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                            {user.container_name ?? ""}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                            {user.status ?? ""}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                            {user.total_amount ?? ""}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                            {user.total_ctn ?? ""}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                            {user.total_gw ?? ""}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 9 }} align="center">
                            {user.total_t_cbm ?? ""}
                          </TableCell>
                        </Box>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Pagination {...pager} />
              </>
            )}

            {/* </TableContainer> */}
          </Card>
        </SuiBox>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CustomerOrders;
